import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Router, Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
// import { ConnectedRouter } from 'react-router-redux';

import { init } from 'modules/app';
import PrivateRoute from 'utils/privateRoute';

import App from 'components/App';
import Header from 'components/Header';

import Login from './Login';
import DashboardLayout from './DashboardLayout';

class Pages extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      isLoaded: false,
    };
  }

  async componentDidMount() {
    await this.props.dispatch(init());

    this.setState({
      isLoaded: true,
    });
  }

  render() {
    if ( this.state.isLoaded === false ) {
      return (
        <div className="outer-content-wrapper">
          <Header />
    
          <div className="main-section" role="main">
            <div className="wrapper wrapper--full">
              <div className="main-content">
                <div className="content-wrapper form-wrapper show">
                  <div className="form-wrapper-blocker">
                    <div className="loader">
                      <i className="icon-loading"></i>
                      <span className="screen-reader-text">Loading...</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return (
      <Router history={this.props.history}>
        <App>
          <Switch>
            <Route exact path="/login" component={Login} />
            <PrivateRoute path="/" component={DashboardLayout} />
          </Switch>
        </App>
      </Router>
    );
  }
}

export default connect()(Pages);



// WEBPACK FOOTER //
// ./src/pages/index.js